import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Paging {
  page: number;
  perPage: number;
  pageCount: number;
  totalCount: number;
}

export interface NotificationForm {
  id: number;
  irbApplicationId: number;
  userId: string,
  type: string, 
  remarks: string,
  createdDate: Date,
  updatedDate: Date,
  status: string,
  assignedUserId: string,
  signature: string, 
  decisionDate: Date,
}

export interface NotificationFormResponse {
  status: string;
  message: string;
  data: Array<NotificationForm>;
}

export interface NotificationFormInfo {
  notificationRequests: NotificationFormResponse;
  message: string;
}

@Module
export default class NotificationFormModule extends VuexModule implements NotificationFormInfo {
  notificationRequests = {} as NotificationFormResponse;
  notificationEdit = {} as NotificationForm;
  message = "";

  get currentNotificationFormRequests(): NotificationFormResponse {
    return this.notificationRequests;
  }

  get getNotificationFormMessage(): string {
    return this.message;
  }

  get currentNotificationFormRequestEdit(): NotificationForm {
    return this.notificationEdit;
  }

  @Mutation
  [Mutations.SET_NOTIFICATION_FORM_REQUESTS](facultyRequests) {
    this.notificationRequests = facultyRequests;
  }

  @Mutation
  [Mutations.SET_NOTIFICATION_FORM_EDIT](notificationEdit) {
    this.notificationEdit = notificationEdit;
  }

  @Mutation
  [Mutations.SET_NOTIFICATION_FORM_MESSAGE](message) {
    this.message = message;
  }

  @Action
  [Actions.POST_NOTIFICATION_FORM](data) {
    return new Promise<void>((resolve, reject) => {
      this.context.commit(Mutations.SET_IRB_ERROR, "");
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("notification/submit", data)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_IRB_ERROR, data.message);
            resolve();
          })
          .catch(({ response }) => {
            this.context.commit(Mutations.SET_IRB_ERROR, response.data.message);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_IRB_ERROR, "");
        reject();
      }
    });
  }

  @Action
  [Actions.GET_NOTIFICATION_FORMS](context) {
    const url = "notification";
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.query(url, {params: context.params})
          .then(({ data }) => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, data.data);
            resolve();
          })
          .catch(() => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
        reject();
      }
    });
  }

  @Action
  [Actions.GET_NOTIFICATION_FORM](id) {
    const url = "notification/" + id;
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get(url)
          .then(({ data }) => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_EDIT, data.data);
            resolve();
          })
          .catch(() => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_EDIT, {});
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_NOTIFICATION_FORM_EDIT, {});
        reject();
      }
    });
  }

  @Action
  [Actions.GET_NOTIFICATION_FORMS_CHAIR](context) {
    const url = "notification/irbchair";
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.query(url, {params: context.params})
          .then(({ data }) => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, data.data);
            resolve();
          })
          .catch(() => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
        reject();
      }
    });
  }

  @Action
  [Actions.GET_NOTIFICATION_FORMS_MEMBER](context) {
    const url = "notification/irbmember";
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.query(url, {params: context.params})
          .then(({ data }) => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, data.data);
            resolve();
          })
          .catch(() => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
        reject();
      }
    });
  }

  @Action
  [Actions.GET_NOTIFICATION_FORMS_AVAILABLE](params) {
    if (params == null || params.params == null) {
      return;
    }
    return new Promise<void>((resolve, reject) => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.query("notification/available", {params: params.params})
          .then(({ data }) => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, data.data);
            resolve();
          })
          .catch(() => {
            this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
            reject();
          });
      } else {
        this.context.commit(Mutations.SET_NOTIFICATION_FORM_REQUESTS, null);
        reject();
      }
    });
  }

}
